import { commonCreateArticleFields } from "../../../articles/components/articleForm";

export default {
  ...commonCreateArticleFields({ allowDecimals: false }),
  "sheet.material": {
    defaultValue: ""
  },
  "sheet.length": {
    defaultValue: null,
    error: (length, { sheet: { area } = {} }) => length <= 0 && !area,
    convert: value => parseFloat(value) || null, // input -> value
    convertBack: value => value || "" // value -> input
  },
  "sheet.width": {
    defaultValue: null,
    error: (width, { sheet: { area } = {} }) => width <= 0 && !area,
    convert: value => parseFloat(value) || null, // input -> value
    convertBack: value => value || "" // value -> input
  },
  "sheet.area": {
    defaultValue: null,
    error: (area, { sheet: { width, length } = {} }) =>
      area <= 0 && (!width || !length),
    convert: value => parseFloat(value) || null, // input -> value
    convertBack: value => value || "" // value -> input
  },
  "sheet.thickness": {
    defaultValue: null,
    error: thickness => !isNaN(thickness) && thickness <= 0,
    convert: value => parseFloat(value) || null, // input -> value
    convertBack: value => value || "" // value -> input
  },
  "sheet.specificWeight": {
    defaultValue: null,
    error: specificWeight =>
      !isNaN(specificWeight) && parseFloat(specificWeight) <= 0,
    convert: value => parseFloat(value) || null, // input -> value
    convertBack: value => value || "" // value -> input
  }
};
